













require('axios')
import { Component, Prop, Vue } from 'vue-property-decorator';
import NewApi, { BasePath, ImagePath, ImageCoverPath } from '../ts/api';
import { DefaultApi, Image, Credentials, Award } from '../api';


let api: DefaultApi;

const AwardProps = Vue.extend({
  props: {
    id: Number,
  }
});

@Component(
  {
    components:{

    }
  }
)
export default class GalleryOverview extends AwardProps {
  awards = [] as Award[];
  
  mounted(){
    api = NewApi()
    api.awardGet().then(r => this.awards = r.data.filter(a => a.owner == this.id).sort((a,b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))).catch(e => console.error("could not fetch images"))
  }

sortDate(a :Award, b :Award){
  return a.date > b.date
}

  getImageUrl(filename: string) {
    return ImageCoverPath(filename)
  }

}
